import { pxToRem } from '../../spacing/utils.js';

var none = '0';
var xs = pxToRem(2);
var sm = pxToRem(4);
var md = pxToRem(6);
var lg = pxToRem(12);
var circle = '50%';
var borderRadiusTokens = {
  none: none,
  xs: xs,
  sm: sm,
  md: md,
  lg: lg,
  circle: circle
};

export { borderRadiusTokens };
